import { render } from "./ViewTenant.vue?vue&type=template&id=1ddde99d&ts=true"
import script from "./ViewTenant.vue?vue&type=script&lang=ts"
export * from "./ViewTenant.vue?vue&type=script&lang=ts"

import "./ViewTenant.vue?vue&type=style&index=0&id=1ddde99d&lang=scss"

import exportComponent from "/var/www/tenanthub.au/runners/admin/root/tenanthub-admin/tenanthub-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__